<template>
    <v-layout row>
        <v-flex xs12>
            <v-stepper v-model="e1">
                <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">Conceptos</v-stepper-step>
                        <v-divider></v-divider>
                    <v-stepper-step step="2">Confirmar</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card class="mb-5 elevation-0">
                           <v-container grid-list-xl>
                          <v-form ref="formconceptos" v-model="validconceptos" lazy-validation @submit.prevent="">
                              <v-layout wrap row>
                                    <v-flex xs12 align-center justify-center>
                                        <v-autocomplete
                                            :filter="customFilter"
                                            v-model="form.concepts"
                                            :disabled="isUpdating"
                                            :items="filterConceptsSelect"
                                            :rules="[v => this.form.concepts_old > 0 ? true : v.length > 0 || 'Seleccione un concepto']"
                                            chips
                                            color="blue-grey lighten-2"
                                            label="Conceptos"
                                            item-text="name"
                                            item-value="id"
                                            multiple
                                            autofocus
                                            return-object
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                    :selected="data.selected"
                                                    close
                                                    class="chip--select-multi"
                                                    @input="remove(data.item)"
                                                >
                                                {{ data.item.code }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.code + ' - ' +data.item.name"></v-list-tile-title>
                                                </v-list-tile-content>
                                            </template>
                                        </v-autocomplete>
                                        <v-data-table
                                            :items="form.concepts"
                                            class="elevation-0"
                                            hide-actions
                                            hide-headers
                                            no-data-text=""
                                        >
                                            <template v-slot:items="props">
                                                <td v-if="props.item.id == 3">1</td>
                                                <td v-if="props.item.id != 3"><vue-numeric-input :value="form.concepts[props.index].qty" :min="1" :max="10" @change="changeQty($event,props.item)" size="50px" align="center" controls-type="updown"></vue-numeric-input></td>
                                                <td>{{ props.item.name }}</td>
                                                <td class="text-xs-right">{{ props.item.concept_cost_last_amount == null ? 0 : props.item.concept_cost_last_amount.amount }} X {{ props.item.qty }}</td>
                                            </template>
                                            <template v-slot:footer>
                                                <tr>
                                                    <td colspan="2">
                                                        <strong>Sub-Total</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ subTotalCostConcepts }}</strong>
                                                    </td>
                                                </tr>
                                                <tr v-for="(index, imp) in filterTaxConcepts" :key="imp">
                                                    <td colspan="2">
                                                        <strong>{{ imp }}</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ index.length == 0 ? 0 : index }}</strong>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2">
                                                        <strong>Total</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ totalCostConcepts }}</strong>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                      </v-card>
                        <v-card-actions>
                            <v-btn color="primary darken-1" @click="backToSearchCpc">Atras</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="setDataConcepts">Siguiente</v-btn>
                            <v-btn flat @click="backToSearchCpc">ELIMINAR</v-btn>
                        </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <v-card class="mb-5 elevation-0">
                            <v-form ref="formpago" v-model="validpago" lazy-validation>
                                <v-layout justify-center>
                                    <v-flex xs12 sm6 md6 lg4 align-center justify-center>
                                        <v-text-field
                                            ref="rif"
                                            v-model="form.rif"
                                            prepend-icon="receipt"
                                            label="RIF"
                                            :rules="[v => !!v || 'RIF es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            ref="razonsocial"
                                            v-model="form.razon_social"
                                            prepend-icon="receipt"
                                            label="Razon social"
                                            :rules="[v => !!v || 'Razon social es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            ref="direccionfiscal"
                                            v-model="form.direccion_fiscal"
                                            prepend-icon="receipt"
                                            label="Direccion Fiscal"
                                            :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-select
                                            prepend-icon="account_balance_wallet"
                                            :items="wayToPay"
                                            v-model="form.way_to_pay"
                                            @change="changeWayToPay"
                                            label="Método de pago"
                                            :rules="[v => !!v || 'Método de pago es requerido']"
                                            required
                                        ></v-select>
                                        <v-select
                                            prepend-icon="credit_card"
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO'"
                                            :items="electronicPoint"
                                            v-model="form.electronic_point_id"
                                            label="Punto electrónico"
                                            item-text="name"
                                            item-value="id"
                                            :rules="[v => !!v || 'Punto electrónico es requerido']"
                                            required
                                        ></v-select>
                                        <v-text-field
                                            ref="amount"
                                            v-model="form.total"
                                            prepend-icon="receipt"
                                            label="Monto"
                                            readonly
                                        ></v-text-field>
                                        <v-select
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                            prepend-icon="account_balance"
                                            :items="banks"
                                            v-model="form.bank_id"
                                            item-text="name"
                                            item-value="id"
                                            label="Banco"
                                            :rules="[v => !!v || 'Banco de pago es requerido']"
                                            required
                                        ></v-select>
                                        <v-text-field
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                            ref="number"
                                            v-model="form.number"
                                            prepend-icon="receipt"
                                            label="Número de transacción"
                                            :rules="[v => !!v || 'Número de transacción es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-flex xs12>
                                            <v-menu
                                                ref="menu"
                                                lazy
                                                :close-on-content-click="false"
                                                v-model="menu"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                :nudge-right="40"
                                                min-width="290px"
                                                :return-value.sync="date"
                                            >
                                                <v-text-field
                                                slot="activator"
                                                label="Fecha"
                                                v-model="computedDateFormattedFecha"
                                                hint="DD/MM/YYYY formato"
                                                prepend-icon="event"
                                                :rules="[v => !!v || 'Fecha es requerido']"
                                                required
                                                readonly
                                                ></v-text-field>
                                                <v-date-picker v-model="form.payment_date" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                                <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-textarea
                                            prepend-icon="reorder"
                                            v-model="form.observations"
                                            auto-grow
                                            color="primary"
                                            label="Observación"
                                            rows="2"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card>
                        <v-card-actions>
                            <v-btn color="primary darken-1" @click="backToConceptos">Atras</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn :loading="loading" color="primary" @click="confirmData">Procesar</v-btn>
                            <v-btn flat @click="backToSearchCpc">ELIMINAR</v-btn>
                        </v-card-actions>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-flex>
        <v-layout row justify-center>
            <v-dialog v-model="print" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Factura</span>
                    </v-card-title>
                    <v-card-text>
                        <FacturaPago :data="dataFactura" v-if="print"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="closeModalFactura">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" color="primary darken-1" flat v-print="'#printMe'">Imprimir Factura</v-btn>
                        <!-- <v-btn color="primary darken-1" flat>Troquelar</v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import VueNumericInput from 'vue-numeric-input'
import FacturaPago from '~/components/factura/FacturaPago.vue'

export default {

    name: 'pagos-view',

    props: {
        information: {
            Type: Object,
            required: true
        }
    },

    components: {
        VueNumericInput,
        FacturaPago
    },

    computed: {

        ...mapGetters({
            existCPC: 'existCPC',
            saldo_deudor: 'getSaldoDeudor',
            solvencia: 'getSolvencia',
            incremento: 'getIncremento',
            sostenimiento: 'getSostenimiento',
            agremiado: 'getAgremiadoData',
            othersRuaps: 'getSatOtherRuap',
            conceptsServices: 'conceptsServices',
            banks: 'getAllBanks',
            print: 'printFacturaPay',
            dataFactura: 'dataFacturaPay',
            electronicPoint: 'getElectronicPoints'
        }),

        filterConceptsSelect () {
            return this.conceptsServices.filter(c => c.id != 9 && c.id != 13)
        },

        totalCostConcepts () {
            let sumaImpuestos = 0
            let concepts = 0

            for(var imp in this.filterTaxConcepts) {
                sumaImpuestos += this.filterTaxConcepts[imp]
            }

            concepts = parseFloat(this.form.concepts.reduce((total, c) => parseFloat(total) + parseFloat(c.concept_cost_last_amount == null ? 0 : (c.concept_cost_last_amount.amount * c.qty)), sumaImpuestos))

            return  concepts;
        },

        subTotalCostConcepts () {
            let concepts = 0

            concepts = parseFloat(this.form.concepts.reduce((total, c) => parseFloat(total) + parseFloat(c.concept_cost_last_amount == null ? 0 : (c.concept_cost_last_amount.amount * c.qty)), 0))

            return  concepts;
        },

        filterTaxConcepts () {
            var esto = this
            let objA = this.form.concepts.map(item => item.concept_tax_last_porcent).reduce(function(groups, item) {
                            for (let index = 0; index < item.length; index++) { //recorro los tax del concepto
                                const val = item[index].code; //codigo concepto
                                let conceptMonto = esto.form.concepts.find(concept => concept.id === item[index].pivot.concept_id) // buscamos el concepto con el mismo id del tax concept id
                                conceptMonto = conceptMonto.concept_cost_last_amount == null ? 0 : (conceptMonto.concept_cost_last_amount.amount * conceptMonto.qty) // multiplicamos el monto por la cantidad de conceptos seleccionados

                                if(groups[val]){ // si existe el tax
                                    let val1 = parseFloat(item[index].amount) / 100 // iva 0.18 example
                                    groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                }else { // de no existir
                                    let val1 = parseFloat(item[index].amount) / 100 // iva 0.18 example
                                    groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                }

                            }

                            return groups
                        }, {})

            let objB = this.form.concepts_old.reduce(function(groups, item) {
                            let cuotaObj = esto.conceptsServices.find(concept => concept.id === 9) // buscamos todo el objeto de cuotas
                            let incrementoObj = esto.conceptsServices.find(concept => concept.id === 13) // buscamos todo el objeto de imcremento

                            if(cuotaObj.id == item.concept_id) {
                                for (let index = 0; index < cuotaObj.concept_tax_last_porcent.length; index++) { // for de conceptos cuota old
                                    const val = cuotaObj.concept_tax_last_porcent[index].code; //codigo concepto
                                    let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                                    if(groups[val]){ // si existe el tax
                                        let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                    }else { // de no existir
                                        let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                    }
                                }
                            }else if(incrementoObj.id == item.concept_id) {
                                for (let index = 0; index < incrementoObj.concept_tax_last_porcent.length; index++) { // for de conceptos incremento old
                                    const val = incrementoObj.concept_tax_last_porcent[index].code; //codigo concepto
                                    let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                                    if(groups[val]){ // si existe el tax
                                        let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                    }else { // de no existir
                                        let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                    }
                                }
                            }

                            return groups
                        }, {})
        
            return Object.keys(objA).concat(Object.keys(objB)).reduce(function(obj, k) {
                obj[k] = (objA[k] || 0) + (objB[k] || 0);
                return obj;
            }, {})
        },

        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }

    },

    watch: {

      isUpdating (val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000)
        }
      }

    },

    mounted () {
        this.checkAuth()
        this.validarCpc()
        this.searchOthersRaps()
    },

    data: () => ({
        value: 1,
        e1: 0,
        date: null,
        taxesC: {},
        taxesCOLD: {},
        menu: false,
        loading: false,
        validcpc: false,
        validpago: false,
        validconceptos: false,
        errCpc: [],
        wayToPay: [
            'PUNTO ELECTRONICO',
            'EFECTIVO - MONEDA LOCAL',
            'EFECTIVO - DIVISAS',
            'TRANSFERENCIA'
        ],
        isUpdating: false,
        form: new Form({
            cpc: '',
            concepts: [],
            concepts_pending: [],
            concepts_old: [],
            imp: [],
            way_to_pay: '',
            electronic_point_id: '',
            number: null,
            ruap_id: null,
            payment_date: '',
            observations: '',
            rif: '',
            razon_social: '',
            direccion_fiscal: '',
            agreement: false,
            total: 0,
            sub_total: 0
        })
    }),

    methods: {

        async validarCpc() {
            this.loading = true
            await this.$store.dispatch('existCpc', this.information.cpc)
            console.log(this.information,'dadasdadasadsadsdsadsa')
            if(this.existCPC != ''){
                this.form.cpc = this.information.cpc
                this.getAllConcepts()
                this.$emit('close-loading')
                this.e1 = 1
            }
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async remove (item) {
            const indexL = this.form.concepts.indexOf(item)
            const index = this.conceptsServices.indexOf(item)
            await this.$store.dispatch('setQtyConcept', {event: 1,index: index})
            if (indexL >= 0) this.form.concepts.splice(indexL, 1)
        },

        async changeWayToPay() {
            if(this.form.way_to_pay != 'PUNTO ELECTRONICO'){
                this.form.electronic_point_id = ''
            }
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async getAllConcepts() {
            await this.$store.dispatch('fetchConceptServicesPayRap',this.information.id)
            this.form.concepts = this.conceptsServices.filter(c => c.id === 3)
        },

        async searchOthersRaps() {
            await this.$store.dispatch('fetchSatSearchOtherRap', { cpc: this.information.cpc, id: this.information.id })
        },

        async checkAuth() {
            await this.$store.dispatch('setModalFacturaPay', false)
            await this.$store.dispatch('fetchUser')
        },

        async setDataConcepts() {
            if (this.$refs.formconceptos.validate() || this.form.concepts_old.length > 0) {
                this.loading = true
                this.form.total = this.totalCostConcepts
                this.form.sub_total = this.subTotalCostConcepts
                this.form.rif = this.agremiado.rif
                this.form.razon_social = this.agremiado.name
                this.form.direccion_fiscal = this.agremiado.direccion_fiscal
                await this.$store.dispatch('setConceptServices', this.form.concepts)
                await this.$store.dispatch('fetchBanks')
                this.e1 = 2
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        customFilter (item, queryText, itemText) {
            const textOne = item.code.toLowerCase()
            const textTwo = item.name.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async confirmData () {
            if (this.$refs.formpago.validate()) {
                this.loading = true
                this.form.agreement = confirm('Esta Seguro de procesar el pago?')
                    if(this.form.agreement){
                        await this.$store.dispatch('sendPayConfirm', this.form)
                    }else{
                        console.log('cancelado el envio')
                    }
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        async changeQty (event,item) {
            const index = this.conceptsServices.indexOf(item)
            console.log(index,'index')

            await this.$store.dispatch('setQtyConcept', {event: event,index: index})
        },

        async addLastpay() {
            this.loading = true
            this.$refs.formconceptos.resetValidation()
            this.sostenimiento.forEach(sost => {
                this.form.concepts_old.push(sost)
            });

            this.incremento.forEach(inc => {
                this.form.concepts_old.push(inc)
            });

            console.log(this.form.concepts_old,'list')

            this.$nextTick(() => {
                this.loading = false
            })
        },

        async deleteLastpay() {
            this.loading = true
            this.form.concepts_old = []
            this.$refs.formconceptos.resetValidation()
            this.$nextTick(() => {
                this.loading = false
            })
        },

        backToSearchCpc () {
            this.loading = true
            this.form = new Form({
                cpc: '',
                concepts: [],
                concepts_pending: [],
                concepts_old: [],
                imp: [],
                way_to_pay: '',
                electronic_point_id: '',
                number: null,
                payment_date: '',
                observations: '',
                agreement: false,
                total: 0,
                sub_total: 0
            })
            // this.$refs.formcpc.resetValidation()
            this.$refs.formconceptos.resetValidation()
            this.e1 = 1
            this.$nextTick(() => {
                this.loading = false
            })
        },

        backToConceptos () {
            this.loading = true
            this.e1 = 1
            this.$refs.formconceptos.resetValidation()
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async addRapToConcept(props) {
            this.loading = true
            await this.$store.dispatch('searchRaupConceptData', props.item.id).then(response => {
                this.form.concepts_pending.push(response.data)
            }, error => {
                console.error(error.response)
            })
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async removeRapToConcept(props) {
            this.loading = true
            var index = this.form.concepts_pending.findIndex(f => f.id === props.item.id)
            this.form.concepts_pending.splice(index, 1)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        checkExistValueRuapPending (props) {
            return this.form.concepts_pending.filter(f => f.ruap_id == props.item.id).length > 0 ? true : false
        },

        async closeModalFactura () {
            // se debe setear todo el storage correspondiente
            await this.$store.dispatch('setModalFacturaPay', false)
            this.$emit('close-pay')
        }

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pagos/pay.vue